import { createContext, useContext } from 'react';

import { comboboxStyles } from './combobox.styles';
import { ComboboxStore } from './useCombobox';

type ComboboxSlots = ReturnType<typeof comboboxStyles>;

export interface ComboboxContextValue {
  store?: ComboboxStore;
  classNames?: Partial<Record<keyof ComboboxSlots, string>>;
  disabled?: boolean;
  invalid?: boolean;
  onOptionSubmit?: (value: string) => void;
}

const ComboboxContext = createContext<ComboboxContextValue>({});

export const ComboboxProvider = ComboboxContext.Provider;

export const useComboboxContext = () => useContext(ComboboxContext);
